import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Box, Typography } from '@material-ui/core';
import { Layout } from '@roc/feature-app-core';
import { DataGrid, AgGridColumnProps, Button } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useRoutes } from '../../hooks/useRoutes';

const columns: AgGridColumnProps[] = [
  {
    field: 'cadenceName',
    headerName: 'Cadence',
    minWidth: 240,
    cellRenderer: 'cadenceLinkRenderer',
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'overdueSteps',
    headerName: 'Overdue Steps',
    minWidth: 120,
    maxWidth: 250,
    comparator: () => 0,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
];

interface Props {
  userId: number;
  rmAe: string;
  onBack: () => void;
}

export const JourneyBuilderOverdueDashboard = observer(({ userId, rmAe, onBack }: Props) => {
  const { salesManagementStore } = useStore();
  const { cadenceRoutesConfig } = useRoutes();
  const { push } = useHistory();
  const gridStore = salesManagementStore.journeyBuilderOverdueGridStore;

  useEffect(() => {
    salesManagementStore.setJourneyBuilderOverdueUserId(userId);
    gridStore.resetAndFetchGridData();
  }, [gridStore, salesManagementStore, userId]);

  const onSortChanged = (params: any) => {
    gridStore.setSortModel(params.api.getSortModel());
  };

  const onFilterChanged = (params: any) => {
    gridStore.setFilterModel(params.api.getFilterModel());
  };

  const frameworkComponents = {
    cadenceLinkRenderer: params => {
      const cadenceId = params?.data?.cadenceId?.toString();
      if (!cadenceId) return params.value ?? null;
      // open the cadence filtered by this RM/AE
      const cadenceUrl = `${cadenceRoutesConfig.cadenceDetailsBackofficeLead(cadenceId).children.cadenceDetailBackofficeLead.url}?originatorId=${userId}`;
      return (
        <a
          href={cadenceUrl}
          style={{ textDecoration: 'underline', color: '#5c94de', cursor: 'pointer' }}
          onClick={e => {
            e.preventDefault();
            push(cadenceUrl);
          }}
        >
          {params.value}
        </a>
      );
    },
  };

  return (
    <Layout>
      <Box display="flex" alignItems="center" style={{ gap: 12 }} p={1} pl={2} flexWrap="wrap">
        <Button testId="backButton" variant="outlined" onClick={onBack} style={{ minWidth: 'auto' }}>
          ← Back
        </Button>
        <Typography variant="h5">Overdue steps by cadence - {rmAe}</Typography>
      </Box>
      <DataGrid
        columns={columns}
        rows={gridStore.gridData.data?.rows ?? []}
        isLoading={gridStore.isLoading}
        showFilters={gridStore.showFilters}
        sortModel={gridStore.sortModel}
        filterModel={gridStore.filterModel}
        paginationData={gridStore.gridData.meta}
        setPageNumber={gridStore.setPageNumber}
        frameworkComponents={frameworkComponents}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
      />
    </Layout>
  );
});
